export interface PCCDetailsFile {
  displayName: string;
  File?: string;
  Action?: string;
  name: string;
  date: Date | string;
  pages?: any;
  addedBy?: string;
  status?: 'Uploded' | 'Uploading' | '';
  checked?: boolean;
  url?: string;
  size?: string;
  downloaded?: boolean;
  'Uploaded On'?: string;
  numOfPages?: number;
  type?: string;
  source?: string;
  listSource?: string;
  lastModified?: number;
  listUploadTime?: string;
  listPages?: number;
  listSize?: number;
  listType?: string;
}
